import SessionId from '@/abTests/sessionId';

const state = {
  sessionId: SessionId(),
};

export default {
  state,
};
